import { useCallback, useEffect, useState } from "react";
import SubCategoryListTable from "./SubCategoryListTable";
import { toast } from "react-toastify";
import Loader from "../Common/Loader";
import { useAppSelector } from "../../Reducers/store";
import AddSubCategoryModal from "./AddSubCategoryModal";
import CommonApi from "../../Api/CommonApi";
import { SubCategory } from "../../Models/SubCategory";
import { Category } from "../../Models/Category";

export default function SubCategoryList() {
  const { userModel } = useAppSelector((state) => state.user);
  const [subCategoryListData, setSubCategoryListData] = useState<SubCategory[]>(
    []
  );
  const [categories, setCategories] = useState<Category[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddSubCategory, setShowAddSubCategory] = useState<boolean>(false);

  const getSubCategories = useCallback(() => {
    if (userModel) {
      try {
        setIsLoading(true);
        return CommonApi.getSubCategories()
          .then((res) => {
            setSubCategoryListData(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error("Error loading subcategories");
            setIsLoading(false);
          });
      } catch (error) {
        console.error(error);
        toast.error("Error loading subcategories");
        setIsLoading(false);
      }
    }
  }, [userModel]);

  const getCategories = useCallback(() => {
    if (userModel) {
      try {
        return CommonApi.getCategories()
          .then((res) => {
            setCategories(res.data);
          })
          .catch((err) => {
            toast.error("Error loading categories");
          });
      } catch (error) {
        console.error(error);
        toast.error("Error loading categories");
      }
    }
  }, [userModel]);

  useEffect(() => {
    setTimeout(() => {
      getSubCategories();
      getCategories();
    }, 100);
  }, []);

  return (
    <>
      <div className="w-full">
        <div className="w-full h-[74px] p-4">
          <div className="mx-1 flex items-end">
            <div className="flex flex-1">
              <h1 className="text-gray-900 font-bold text-4xl">
                <div>SubCategories</div>
              </h1>
            </div>
          </div>
        </div>
        <div className="relative">
          {isLoading && <Loader />}
          <div className="w-full p-4 h-[calc(100vh-132px)] md:h-[calc(100vh-200px)] overflow-y-auto">
            <SubCategoryListTable
              data={subCategoryListData}
              categories={categories}
              onRefresh={getSubCategories}
            />
          </div>
        </div>
      </div>
      <AddSubCategoryModal
        show={showAddSubCategory}
        setShow={setShowAddSubCategory}
        categories={categories}
        getSubCategories={getSubCategories}
      />
    </>
  );
}
